module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/005-ethiopia-15d71813bb0949e92ae6f9efbb78151d.svg";